var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Congratulations",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-congratulations","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <circle cx="60.8" cy="95.6" r="4.1"/>
  <circle cx="54.8" cy="110.9" r="4.1"/>
  <circle cx="78.4" cy="147.1" r="4.1"/>
  <circle cx="192.8" cy="91.9" r="4.1"/>
  <circle cx="153.4" cy="75.8" r="4.1"/>
  <circle cx="194.5" cy="111.7" r="4.1"/>
  <path d="M235.6 198.5l-22.7 6.9-16.9-55.6c.9-.4 1.6-.7 2.1-1 24.5-13.3 23.5-37.3 19.6-48.2L181 .6l-63 19.3 5.6 23.4-61.5-16.4-32.8 98.2-.1.2c-8.9 32.2 11.6 46 20.8 50.4.4.2.8.4 1.2.5l-14.9 56-22.9-6.1-2.3 8.7 54.5 14.5 2.3-8.7-22.9-6.1 15-56.1c.9.2 1.8.2 2.3.3 1 .1 2 .1 3 .1 25.7 0 36.8-20.1 39-30.7l20.6-99.6 17.1 72 .1.2c8.2 28 28.1 32.1 39.2 32.1 1.6 0 3.3-.1 5-.3.4 0 .9-.1 1.3-.2l16.8 55.5-22.7 6.9 2.6 8.6 54-16.4-2.7-8.4zM95.4 146.4c-.2 1-5.3 23.5-30.2 23.5-.8 0-1.6 0-2.5-.1-1.5-.1-6.6-1.1-8.9-2.2-20.7-9.9-18.9-29.1-16-39.8l17.4-52c2.5-.7 9.2-1.7 16.5 5.3.2.1 11.8 10.8 26 10.8 3 0 6.1-.5 9.2-1.6l-11.5 56.1zm13.1-63.2c-6.4 3.7-13.7 3.9-21.6.6-6.5-2.7-11-6.9-11-6.9-7-6.8-13.9-7.8-18.5-7.4L68 37.8l47.3 12.6-6.8 32.8zm67-71.4L187 43.3c-3.5 6.5-9.6 10.5-18 11.9-7 1.1-13 0-13 0-9.5-2-15.9.7-19.7 3.5L128.7 26l46.8-14.2zm9.7 132c-1.3.1-2.7.2-4 .2-19 0-27.1-13.9-30.6-25.6L138 65.1c1.7-1.9 6.9-6.3 16.9-4.2.2.1 22.9 4.4 34.8-10.7l19.6 53.5c.4 1 8.4 24.2-15.4 37.2-1.3.8-6.2 2.6-8.7 2.9z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/congratulations.svg